// Reemplaza las claves dinámicas en el mensaje
export function replaceKeysInMessage(
	message: string,
	keys?: Record<string, string>
): string {
	if (!keys) return message;

	// Reemplaza cada clave en el mensaje por su valor correspondiente
	return Object.entries(keys).reduce((result, [key, value]) => {
		// Create a placeholder in the format [key], e.g., [email]
		const placeholder = `[${key}]`;

		// Escape special characters in the placeholder to avoid issues in the regex
		const escapedPlaceholder = placeholder.replace(
			/[-\/\\^$*+?.()|[\]{}]/g, // Matches special regex characters
			"\\$&" // Escapes them by adding a backslash
		);

		// Replace all occurrences of the placeholder in the message with the actual value
		return result.replace(new RegExp(escapedPlaceholder, "g"), value);
	}, message);
}
